import { deepPurple } from '@mui/material/colors';
import { Box, Card, Grid, Stack, useTheme, Typography } from '@mui/material';

import { useResponsive } from 'src/hooks/use-responsive';

export const DetailHrmFunctions = () => {
  const theme = useTheme();
  const deepPurpleColor = deepPurple.A200;

  const smDown = useResponsive('down', 'sm');
  const padding = () => {
    if (smDown) {
      return 2;
    }
    return 3;
  };
  return (
    <Stack mb={smDown ? 5 : 10}>
      <Stack my={5} spacing={2} alignItems="center">
        <Typography
          fontFamily='"Shantell Sans Light", sans-serif'
          sx={{ color: deepPurpleColor }}
          fontSize={18}
          align="center"
          fontWeight="medium"
        >
          Phần mềm quản lý trung tâm thế hệ mới
        </Typography>
        <Typography variant="h2" align="center">
          Tự động hóa hoạt động quản lý nhân sự
        </Typography>
        <Stack>
          <Typography variant="body1" align="center" maxWidth={808}>
            Quản lý hồ sơ nhân viên, phân quyền, chấm công và đánh giá hiệu suất nhân viên ngay trên
            một nền tảng duy nhất. CenterUp giúp trung tâm kiểm soát công việc, lương thưởng và hiệu
            quả nhân viên minh bạch, chính xác.
          </Typography>
        </Stack>
      </Stack>
      <Stack alignSelf="center" maxWidth={1150}>
        <Grid container justifySelf="center" spacing={4} alignItems="stretch">
          <Grid md={6} sm={12} item>
            <Card
              sx={{
                width: '100%',
                justifySelf: 'center',
                height: '100%',
                background: theme.palette.background.neutral,
                position: 'relative',
              }}
              variant="outlined"
            >
              <Stack height="100%" justifyContent="space-between">
                <Stack zIndex={2} px={padding} pt={padding}>
                  <Typography variant="h5">Hồ sơ nhân sự tập trung</Typography>
                  <Typography variant="subtitle2" fontWeight={400}>
                    Lưu trữ toàn bộ thông tin nhân sự như hợp đồng, bằng cấp, phân công, lịch sử làm
                    việc. Dễ dàng tìm kiếm, cập nhật và đồng bộ với vận hành.
                  </Typography>
                </Stack>
                <Stack>
                  <Box
                    component="img"
                    alt="employee-detail"
                    src="/assets/sub-pages/manage/hrm/info.png"
                    zIndex={2}
                    width="100%"
                    alignSelf="center"
                  />
                </Stack>
              </Stack>
            </Card>
          </Grid>
          <Grid md={6} sm={12} item>
            <Card
              sx={{
                width: '100%',
                justifySelf: 'center',
                height: '100%',
                background: theme.palette.background.neutral,
              }}
              variant="outlined"
            >
              <Stack height="100%" justifyContent="space-between">
                <Stack px={padding} pt={padding}>
                  <Typography variant="h5">
                    Phân quyền chặt chẽ – an toàn dữ liệu nhân sự
                  </Typography>
                  <Typography variant="subtitle2" fontWeight={400}>
                    Phân quyền truy cập hệ thống theo chức danh (quản lý, giảng viên, nhân viên),
                    đảm bảo bảo mật dữ liệu và tối ưu hóa giao diện theo vai trò.
                  </Typography>
                </Stack>{' '}
                <Stack>
                  <Box
                    alignSelf="flex-end"
                    alt="class-dashboard"
                    component="img"
                    width="100%"
                    src="/assets/sub-pages/manage/hrm/role.png"
                    zIndex={2}
                  />
                </Stack>
              </Stack>
            </Card>
          </Grid>
          <Grid md={6} sm={12} item>
            <Card
              sx={{
                width: '100%',
                justifySelf: 'center',
                height: '100%',
                background: theme.palette.background.neutral,
              }}
              variant="outlined"
            >
              <Stack height="100%" justifyContent="space-between">
                <Stack px={padding} pt={padding}>
                  <Typography variant="h5">Chấm công thông minh, với công nghệ FaceId</Typography>
                  <Typography variant="subtitle2" fontWeight={400}>
                    Tự động ghi nhận công theo lịch dạy, lịch làm việc và nhiệm vụ hoàn thành. Phù
                    hợp cả với giáo viên, nhân viên part-time và cộng tác viên.
                  </Typography>
                </Stack>
                <Stack>
                  <Box
                    component="img"
                    alt="class-hrm"
                    src="/assets/sub-pages/manage/hrm/face-id.png"
                    zIndex={2}
                    width="100%"
                    alignSelf="center"
                  />
                </Stack>
              </Stack>
            </Card>
          </Grid>
          <Grid md={6} sm={12} item>
            <Card
              sx={{
                width: '100%',
                justifySelf: 'center',
                height: '100%',
                background: theme.palette.background.neutral,
              }}
              variant="outlined"
            >
              <Stack height="100%" justifyContent="space-between">
                <Stack px={padding} pt={padding} width={1}>
                  <Typography variant="h5">Tính lương tự động</Typography>
                  <Typography variant="subtitle2" fontWeight={400}>
                    Tính lương dựa trên công thực tế, giờ dạy, KPI và quy định thưởng phạt. Tự động
                    hóa hoàn toàn, đồng bộ với hệ thống tài chính.
                  </Typography>
                </Stack>
                <Stack>
                  <Box
                    component="img"
                    alt="class-schedule"
                    src="/assets/sub-pages/manage/hrm/salary.png"
                    zIndex={2}
                    width="100%"
                    alignSelf="center"
                  />
                </Stack>
              </Stack>
            </Card>
          </Grid>
          <Grid md={6} sm={12} item>
            <Card
              sx={{
                width: '100%',
                justifySelf: 'center',
                height: '100%',
                background: theme.palette.background.neutral,
              }}
              variant="outlined"
            >
              <Stack height="100%" justifyContent="space-between">
                <Stack px={padding} pt={padding} width={1}>
                  <Typography variant="h5">Lịch làm việc đồng bộ</Typography>
                  <Typography variant="subtitle2" fontWeight={400}>
                    Lịch dạy, lịch trực, công việc đều kết nối và cảnh báo trùng lịch. Nhân sự dễ
                    theo dõi, quản lý dễ kiểm soát.
                  </Typography>
                </Stack>
                <Stack>
                  <Box
                    component="img"
                    alt="class-schedule"
                    src="/assets/sub-pages/manage/hrm/calendar.png"
                    zIndex={2}
                    width="100%"
                    alignSelf="center"
                  />
                </Stack>
              </Stack>
            </Card>
          </Grid>
          <Grid md={6} sm={12} item>
            <Card
              sx={{
                width: '100%',
                justifySelf: 'center',
                height: '100%',
                background: theme.palette.background.neutral,
              }}
              variant="outlined"
            >
              <Stack height="100%" justifyContent="space-between">
                <Stack px={padding} pt={padding} width={1}>
                  <Typography variant="h5">Theo dõi hiệu suất không còn “cảm tính”</Typography>
                  <Typography variant="subtitle2" fontWeight={400}>
                    Thống kê khối lượng công việc, phản hồi học viên và KPI. Dữ liệu rõ ràng phục vụ
                    đánh giá, khen thưởng, điều chỉnh.
                  </Typography>
                </Stack>
                <Stack>
                  <Box
                    component="img"
                    alt="class-schedule"
                    src="/assets/sub-pages/manage/hrm/report.png"
                    zIndex={2}
                    width="100%"
                    alignSelf="center"
                  />
                </Stack>
              </Stack>
            </Card>
          </Grid>
        </Grid>
      </Stack>
    </Stack>
  );
};
